<template>
  <div class="layout">
s    <div class="content">
      <h2>Wesbite coming soon!</h2>
    </div>
  </div>
</template>

<script>

export default {
  name: "ComingSoon",
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/main.scss";

.layout {
  background-color: #7089ae;
  background-position: 0% 75%;
  background-size: cover;
  min-height: 90vh;
  width: -webkit-fill-available;
  display: grid;
  grid-template-rows: max-content;
  grid-row-gap: 5vh;
  justify-items: center;
  padding: 5vh 5vw;

  h2 {
    text-align: center;
  }

  .content {
    display: grid;
    grid-template-rows: max-content;
    grid-row-gap: 5vh;
    justify-items: center;
  }
}
</style>
